<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12qweGG/tc-custom/9781504088886.jpg?1740446411437" alt="This image is the cover for the book Only You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Only You
      </h1>
      <p class="bookDescription body article font2">
        <b>From the acclaimed author of <i>A Gift Called Hope</i>, a powerful new novel spanning four decades that asks: Can true love survive any betrayal?</b><br/><br/> They fell in love decades ago and dreamed of a big future together. After Ben committed an unforgiveable act and broke Leora’s heart, they went their separate ways—but always wondered what could have been. Ben deeply regretted hurting Leora; what troubled him more, however, was that he had no memory of that fateful night and what he did . . .<br/><br/> Now, years later, their worlds are about to collide in a way they never imagined. But the couple’s reunion is more the stuff of nightmares than fairy tales. Drawn together again by an unforeseen tragedy in a world that has drastically changed since their youthful romance, Ben and Leora are about to discover whether true love really can endure, in this powerful saga of passion, friendship, and betrayal.<br/><br/><b>Praise for Eva Jordan’s novels</b><br/><br/> “An emotional roller-coaster . . . beautifully written.” —<i>The Last Word Book Review</i><br/><br/> “A highly captivating read . . . Fabulous and surprising.” —<i>The Book Review Café</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eva Jordan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3d30ce51